


























































































import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';

import { phaseWebservice } from '@/webservices/phase';
import type { Phase } from '@/models/phase';
import type { User } from '@/models/user';
import { hasPermission } from '@/helpers/auth/permissionHelpers';
import { PERMISSIONS } from '@/helpers/auth/permissions';

@Component({
    name: 'PhasesList',
    computed: {
        PERMISSIONS() {
            return PERMISSIONS;
        },
    },
    methods: { hasPermission },
    components: {},
})
export default class PhasesList extends Vue {
    private phases = new Array<Phase>();

    private tableSettings = {
        openedDetailed: Array<number>(),
        isStriped: true,
        isHoverable: true,
        isPaginated: false,
    };
    @Getter('account/userInfo') private userInfo: User;

    private mounted() {
        this.load();
    }

    private load() {
        phaseWebservice
            .load()
            .then((response) => {
                this.phases = response.data;
            })
            .catch((error) => {
                console.error(error);
            });
    }
}
